import React from 'react';
import { Button, ButtonElevation, ButtonType } from '@prisjakt/ui/button';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { getFractalRepresentation } from './utils';
import { VariantSelectionCallback } from '../types';
import { SelectionButtonText } from './styles';
import { Behavior } from '@prisjakt/ui/text';
import { FilterTypeEnum } from 'src/components/price-list/types';

export const SizeVariantSelectionButton: React.FC<IVariantSelectionButton> = props => {
  const { variant, title, handleSelection } = props;
  const sizeWithFractal = getFractalRepresentation(title);
  const { getFilter } = useOfferListFilterContext();
  const variantSizeFilter = getFilter(FilterTypeEnum.VARIANT_SIZE);
  const selectedSizeVariants = variantSizeFilter?.active
    ? variantSizeFilter?.selection
    : null;
  const isSelected = Boolean(
    (variant && selectedSizeVariants?.includes(variant)) ||
      (!variant && !selectedSizeVariants)
  );

  const onSelect = () => handleSelection(variant);

  return (
    <Button
      onClick={onSelect}
      selectable
      selected={isSelected}
      fullWidth
      type={ButtonType.OUTLINED}
      elevation={ButtonElevation.NONE}
    >
      <SelectionButtonText behavior={Behavior.OnelineEllipsis}>
        {sizeWithFractal}
      </SelectionButtonText>
    </Button>
  );
};

interface IVariantSelectionButton {
  variant: string | null;
  title: string;
  handleSelection: VariantSelectionCallback;
}
